module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_tp_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('a', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_cop_r1"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_ack_r1"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('a', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_p01_r1"
    }
  }, [_vm._v("Part One -  1928 – 1939")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c01_r1"
    }
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c02_r1"
    }
  }, [_vm._v("CHAPTER 2")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c03_r1"
    }
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c04_r1"
    }
  }, [_vm._v("CHAPTER 4")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c05_r1"
    }
  }, [_vm._v("CHAPTER 5")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c18_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c19_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c20_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c21_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c22_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c23_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c24_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two - 1939 – 1942")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c25_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c26_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c27_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c28_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c29_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c30_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c31_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c32_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c33_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c34_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 34")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c35_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 35")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c36_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 36")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c37_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 37")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_p03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three - 1943 – 1946")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c38_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 38")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c39_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 39")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c40_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 40")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c41_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 41")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c42_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 42")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c43_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 43")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c44_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 44")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c45_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 45")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c46_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 46")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c47_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 47")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c48_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 48")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c49_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 49")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c50_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 50")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_c51_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 51")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_elg_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/vinc_9781590207963_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALSO BY THE SAME AUTHOR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a6a8ca7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vinc_9781590207963_oeb_toc_r1.vue
// module id = 63
// module chunks = 0